import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { UserInfoService } from 'src/app/services/user-info.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  // constructor(private router: Router, private _userInfoService: UserInfoService) {}

  // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    
  //   return this.authenticate();
  // }

  // canActivateChild(
  //   childRoute: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot
  // ): boolean | UrlTree {
  //   return this.authenticate();
  // }

  // private authenticate(): boolean | UrlTree {
  //   let t = this._userInfoService.getLoginFlag();
  //   return !!t ? true : this.router.parseUrl('/');
  // }
  constructor(
   // private authService: AuthService,
    private authService: UserInfoService,
    private router: Router) { }
canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | Promise<boolean> {
    var isAuthenticated = this.authService.getLoginFlag();
    if (!isAuthenticated) {
        this.router.navigate(['/login']);
    }

    return isAuthenticated;
}
}
